import React, { useState, useEffect ,useRef} from "react";
import {
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";

import {
  Panel,
  PanelGroup,
  PanelResizeHandle,
} from "react-resizable-panels";




import AppHeader from "../components/AppHeader";
import FourthTree from "../components/FourthTree";
import ParametersTable from "../components/ParametersTable";
import SpecificationsAccordion from "../components/SpecificationsAccordion";

import {
  ParameterAPI,
  MeasureAPI,
  BlobAPI,
} from "../services/api";

import { useSession } from "../context/SessionContext";

const FourthPanel = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const location = useLocation();

  const [projectName, setProjectName] = useState(
    location.state?.projectName ||
      localStorage.getItem("projectName") ||
      ""
  );

  const userName = localStorage.getItem("userName");

  const { sessionNo } = useSession();

  const [selectedNode, setSelectedNode] = useState<any>(null);

  const [parameters, setParameters] = useState<any[]>([]);

  const [loadingParams, setLoadingParams] = useState(false);

  const [imageUrl, setImageUrl] =
    useState<string | null>(null);

  
 const [showLens, setShowLens] = useState(false);

const [lensPos, setLensPos] = useState({
  x: 0,
  y: 0,
});

const [zoomPos, setZoomPos] = useState({
  x: 50,
  y: 50,
});

const LENS_SIZE = 240;

const ZOOM = 2.5;

const imageRef = useRef<HTMLImageElement>(null);

const lensCanvasRef = useRef<HTMLCanvasElement>(null);

const [mousePos, setMousePos] = useState({
  x: 0,
  y: 0,
});

  const handleNodeSelect = async (node: any) => {

    setSelectedNode(node);

    try {

      setLoadingParams(true);

      const data = await ParameterAPI.getBySet(
        node.tag,
        Number(id),
        sessionNo!
      );

      setParameters(data);

    } catch (err) {

      console.error(err);

      setParameters([]);

    } finally {

      setLoadingParams(false);

    }
  };

  const handleUpdateParameters = async (
    updated: any[],
    index: number,
    field: string
  ) => {

    const item = updated[index];

    try {

      if (field === "value") {

        const result =
          await MeasureAPI.update({

            wmno: item.id,

            sno: sessionNo!,

            mval: Number(item.value),

            axn: "ParameterUpdate",

          });

        const changed =
          result.Q_Parameters ?? [];

        if (changed.length > 0) {

          setParameters(
            changed.map((p: any) => ({
              id: p.ParameterNo,
              parameter: p.Parameter,
              value: p.Value,
            }))
          );

        } else {

          setParameters(updated);

        }
      }

    } catch (err) {

      console.error(err);

    }

  };

  useEffect(() => {

    const loadImage = async () => {

      if (!selectedNode) {

        setImageUrl(null);

        return;

      }

      try {

        let url = null;

        if (
          selectedNode.notationNo &&
          selectedNode.notationHead
        ) {

          url = await BlobAPI.getImage(
            "Notation1",
            selectedNode.notationHead
          );

        } else if (
          selectedNode.wbsNo &&
          selectedNode.sequence
        ) {

          url = await BlobAPI.getImage(
            "WorkTree1",
            selectedNode.sequence
          );

        }

        setImageUrl(url);

      } catch {

        setImageUrl(null);

      }

    };

    loadImage();

  }, [selectedNode]);


  useEffect(() => {
  if (
    !showLens ||
    !imageRef.current ||
    !lensCanvasRef.current
  ) {
    return;
  }

  const img = imageRef.current;
  const canvas = lensCanvasRef.current;
  const ctx = canvas.getContext("2d");

  if (!ctx) return;

  const scaleX = img.naturalWidth / img.clientWidth;
  const scaleY = img.naturalHeight / img.clientHeight;

  //const sourceSize = 80;
  //const sourceSize = LENS_SIZE / ZOOM;

  const sourceSize = 200;

  const sx = mousePos.x * scaleX - sourceSize / 2;
  const sy = mousePos.y * scaleY - sourceSize / 2;

  ctx.clearRect(0, 0, LENS_SIZE, LENS_SIZE);

  //ctx.imageSmoothingEnabled = false;
  ctx.imageSmoothingEnabled = true;
ctx.imageSmoothingQuality = "high";

  ctx.drawImage(
    img,
    sx,
    sy,
    sourceSize,
    sourceSize,
    0,
    0,
    LENS_SIZE,
    LENS_SIZE
  );

}, [mousePos, showLens]);



  /* const handleImageMove = (
  e: React.MouseEvent<HTMLDivElement>
) => {

  const rect = e.currentTarget.getBoundingClientRect();

  const x = e.clientX - rect.left;

  const y = e.clientY - rect.top;

  setLensPos({ x, y });

  setZoomPos({
    x: (x / rect.width) * 100,
    y: (y / rect.height) * 100,
  });
 
};*/
const handleImageMove = (
  e: React.MouseEvent<HTMLDivElement>
) => {
  if (!imageRef.current) return;

  const imageRect = imageRef.current.getBoundingClientRect();
  const containerRect = e.currentTarget.getBoundingClientRect();

  const displayX = e.clientX - imageRect.left;
  const displayY = e.clientY - imageRect.top;

  if (
    displayX < 0 ||
    displayY < 0 ||
    displayX > imageRect.width ||
    displayY > imageRect.height
  ) {
    setShowLens(false);
    return;
  }

  setShowLens(true);

 setMousePos({
  x: displayX,
  y: displayY,
});

  setLensPos({
    x:
      imageRect.left -
      containerRect.left +
      displayX,

    y:
      imageRect.top -
      containerRect.top +
      displayY,
  });
};

 

if (!id) {
  return <div>Invalid Project</div>;
}

if (sessionNo === null) {
  return <div>Loading...</div>;
}


  

  return (

<div
className="h-screen flex flex-col bg-gray-100"
style={{
fontFamily:"Segoe UI",
fontSize:"13px",
fontWeight:400,
}}
>

<AppHeader
title={projectName || id || "Parameters"}
userName={userName}
activeTab="fourth"
onBack={()=>navigate(-1)}
onHome={()=>navigate("/projects")}
onDashboard={()=>navigate(`/project/${id}`,{state:{projectName}})}
onSecond={()=>navigate(`/project/${id}/second`,{state:{projectName}})}
onThird={()=>navigate(`/project/${id}/third`,{state:{projectName}})}
onFourth={()=>navigate(`/project/${id}/fourth`,{state:{projectName}})}
onFifth={() => navigate(`/project/${id}/fifth`, { state: { projectName } })}
/* onLogout={()=>{
localStorage.removeItem("token");
navigate("/login");
}} */
/* onLogout={() => {
  Object.keys(sessionStorage).forEach((key) => {
    if (
      key.startsWith("treeSelection-") ||
      key.startsWith("treeOpenNodes-")
    ) {
      sessionStorage.removeItem(key);
    }
  });

  localStorage.removeItem("token");
  navigate("/login");
}}
 */
onLogout={() => {
  sessionStorage.clear();

  localStorage.removeItem("token");

  navigate("/login");
}}

projectId={Number(id)}
onProjectUpdated={setProjectName}
/>

<div className="flex-1 min-h-0 overflow-hidden">

<PanelGroup direction="horizontal">

<Panel defaultSize={25} minSize={15}>

<div className="flex flex-col h-full bg-white">

<div className="px-4 pt-4 pb-2">

<h2> Work Breakdown Structure</h2>

</div>

<div className="flex-1 overflow-y-auto">

<FourthTree

projectId={Number(id)}

onSelect={handleNodeSelect}

/>

</div>

</div>

</Panel>

<PanelResizeHandle className="w-[1px] bg-gray-500"/>

{/* <Panel defaultSize={75} minSize={20}>

<div className="flex flex-col h-full bg-white"> */}
<Panel defaultSize={75} minSize={20}>

<PanelGroup direction="horizontal">

  {/* Middle Panel (Existing Content) */}
  <Panel defaultSize={50} minSize={20}>

    <div className="flex flex-col h-full bg-white">
<div className="px-4 pt-4 pb-1">
  <h2 className="text-gray-700 flex items-center gap-2 leading-none">
    📊 Detail Area
  </h2>
</div>

<div
  className="flex-1 min-h-0 overflow-y-auto hide-scrollbar p-0 space-y-0"
  style={{ backgroundColor: "#FFFFFF" }}
>
  <div>
    
    {parameters.length === 0 ? (
      <div className="flex items-center justify-center h-40 text-gray-400">
         No Parameters for this node
      </div>
    ) : (
      <ParametersTable
        data={parameters}
        loading={loadingParams}
        onUpdate={handleUpdateParameters}
      />
    )}
  </div>

  <div>
    <SpecificationsAccordion
      projectId={Number(id)}
      selectedNode={selectedNode}
    />
  </div>

  {/* <div className="pt-1">
    <div className="w-full bg-white flex flex-col items-center">

      {imageUrl ? (
        <>
          <div
            className="relative"
            onMouseEnter={() => setShowZoom(true)}
            onMouseLeave={() => setShowZoom(false)}
            onMouseMove={handleImageMove}
          >
            <img
              src={imageUrl}
              alt="Preview"
              className="max-h-[280px] max-w-full object-contain"
            />

            {showZoom && (
              <div
                style={{
                  position: "absolute",
                  width: 120,
                  height: 120,
                  left: lensPos.x - 60,
                  top: lensPos.y - 60,
                  border: "2px solid #666",
                  background: "rgba(255,255,255,0.35)",
                  pointerEvents: "none",
                  boxSizing: "border-box",
                }}
              />
            )}
          </div>

          {showZoom && (
            <div
              className="mt-2 h-72 w-full border border-gray-300 overflow-hidden"
              style={{
                backgroundImage: `url(${imageUrl})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "250%",
                backgroundPosition: `${zoomPos.x}% ${zoomPos.y}%`,
              }}
            />
          )}
        </>
      ) : (
        <></>
      )}

    </div>
  </div> */}
</div>
        {/* </div>
      </Panel>
    </PanelGroup>
  </div>
</div> */}
        </div>

      </Panel>

      {/* <PanelResizeHandle className="w-px bg-gray-300" /> */}
      <PanelResizeHandle className="w-0 bg-transparent" />
      {/* Right Panel (Empty) */}
      <Panel defaultSize={50} minSize={20}>

  <div className="flex flex-col h-full bg-white">

    
    {/* <div className="flex-1 overflow-auto p-2"> */}
    <div className="flex-1 overflow-hidden">

  
  {/* <div className="w-full h-full bg-gray-100"> */}
  <div
   className="w-full h-full bg-white relative"
 /*  style={{
    background: "#f5f5f5",
    position: "relative",
  }} */
>

  {imageUrl ? (

    <div
     // className="relative w-full h-full flex items-center justify-center overflow-hidden"
     
  //className="relative w-full h-full overflow-hidden"
  className="relative w-full h-full flex items-center justify-center overflow-hidden"

      onMouseEnter={() => setShowLens(true)}

      onMouseLeave={() => setShowLens(false)}

      onMouseMove={handleImageMove}
    >

     <img
  ref={imageRef}
  src={imageUrl}
  alt="Preview"
  draggable={false}
 style={{
 

 
maxWidth: "100%",
maxHeight: "100%",
width: "100%",
height: "100%",
  objectFit: "contain",
  objectPosition: "center",
  userSelect: "none",
  pointerEvents: "none",
  display: "block",
}}
/> 

     
        {showLens && imageRef.current && (
  <div
    style={{
      position: "absolute",
      left: lensPos.x - LENS_SIZE / 2,
      top: lensPos.y - LENS_SIZE / 2,
      width: LENS_SIZE,
      height: LENS_SIZE,
      borderRadius: "50%",
      overflow: "hidden",
      border: "4px solid black",
      pointerEvents: "none",
      background: "#fff",
      boxShadow: "0 0 15px rgba(0,0,0,.45)",
      zIndex: 100,
    }}
  >
  <canvas
  ref={lensCanvasRef}
  width={LENS_SIZE}
  height={LENS_SIZE}
  style={{
    width: "100%",
    height: "100%",
    display: "block",
  }}
/>

  </div>
)}

      

    </div>

  ) : (

    <div className="flex items-center justify-center h-full text-gray-400">
      No Image
    </div>

  )}

</div>
  

    </div>

  </div>

</Panel>

    </PanelGroup>

  </Panel>

</PanelGroup>

</div>
</div>
  );
};

export default FourthPanel;